import { create } from "zustand";
import { persist } from "zustand/middleware";
import api from "../api/client";

const useAuthStore = create(
  persist(
    (set, get) => ({
      // Seeker
      seekerToken: null,
      seekerUser: null,
      setSeekerAuth: (token, user) =>
        set({ seekerToken: token, seekerUser: user }),
      clearSeekerAuth: () => set({ seekerToken: null, seekerUser: null }),
      refreshSeekerUser: async () => {
        const { seekerToken } = get();
        if (!seekerToken) return null;
        try {
          const { data } = await api.get("/users/me");
          set({ seekerUser: data });
          return data;
        } catch (err) {
          console.error("Failed to refresh seeker user:", err);
          return null;
        }
      },
      // Employer
      employerToken: null,
      employerUser: null,
      setEmployerAuth: (token, employer) =>
        set({ employerToken: token, employerUser: employer }),
      updateEmployerUser: (employer) => set({ employerUser: employer }),
      clearEmployerAuth: () => set({ employerToken: null, employerUser: null }),
    }),
    {
      name: "joborigo-auth",
    },
  ),
);

export default useAuthStore;
